export default __webpack_public_path__ + "static/solution_back-325ffb9124433ded3ce572184bd90e7f.webp";